import { useLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';

import { filterByBrandTagAndLocale } from './utils';

export type WebsiteDataResult = ReturnType<typeof useWebsiteData>;

export type WebsiteDataQueryResult = {
  allContentstackSettings: {
    nodes: {
      site_name: string;
      default_locale: string;
      tags: string[];
      publish_details: {
        locale: string;
      };
    }[];
  };
  allContentstackHeader: {
    nodes: {
      logo: {
        large_image: {
          url: string;
        };
      };
      tags: string[];
      publish_details: {
        locale: string;
      };
    }[];
  };
};

export const useWebsiteData = (locale: string) => {
  const { href, origin } = useLocation();

  const result = useStaticQuery<WebsiteDataQueryResult>(
    graphql`
      {
        allContentstackSettings {
          nodes {
            site_name
            default_locale
            tags
            publish_details {
              locale
            }
          }
        }
        allContentstackHeader {
          nodes {
            logo {
              large_image {
                url
              }
            }
            tags
            publish_details {
              locale
            }
          }
        }
      }
    `
  );

  const {
    allContentstackSettings: { nodes: settingsNodes },
    allContentstackHeader: { nodes: headerNodes },
  } = result;

  const settings = settingsNodes.find((item) =>
    filterByBrandTagAndLocale(locale, item.tags, item.publish_details.locale)
  );

  const logo = headerNodes.find((item) =>
    filterByBrandTagAndLocale(locale, item.tags, item.publish_details.locale)
  );

  return { settings, logo, href, origin };
};
